module.exports = "/_next/static/images/e56c22cc4ab75fcf285a04f4777ac5f5-careers@0.75x.jpg";